import type { InfractionText } from './types';

export const portInfractions: Record<string, InfractionText> = {
  HIGH_PORT_EXPOSED: {
    infraction: '{service} port exposed',
    explanation:
      'Port {port} is used for {service}, which potentially exposes files, documents, and data that could include sensitive business information or personal data.',
    whyRisk: 'Why is this a high risk?',
    risk: 'Weak access controls or misconfigurations in {service} could allow unauthorised users to download, modify, or delete critical files.',
  },
  MEDIUM_PORT_EXPOSED: {
    infraction: '{service} port exposed',
    explanation:
      'Port {port} is used for {service}, which potentially exposes files, documents, and data that could include sensitive business information or personal data.',
    whyRisk: 'Why is this a medium risk?',
    risk: 'Weak access controls or misconfigurations in {service} could allow unauthorised users to download, modify, or delete critical files.',
  },
  LOW_PORT_EXPOSED: {
    infraction: '{service} port exposed',
    explanation:
      'Port {port} is used for {service}, which potentially exposes files, documents, and data that could include sensitive business information or personal data.',
    whyRisk: 'Why is this a low risk?',
    risk: 'Weak access controls or misconfigurations in {service} could allow unauthorised users to download, modify, or delete critical files.',
  },
};
